import {
  GetBookingWithUuidQuery,
  GetBookingWithUuidQueryVariables,
} from "@/types/gql/generated/graphql";
import { apolloClient } from "@/utils/graphql-client";
import { GET_BookingWithUUID } from "./queries/product-slot-booking.graphql";

/**
 * Returns Booking using uuid.
 *
 * @param uid booking uuid
 */
export async function getBookingWithUUID(uid: string) {
  const res = await apolloClient.query<
    GetBookingWithUuidQuery,
    GetBookingWithUuidQueryVariables
  >({
    query: GET_BookingWithUUID,
    variables: { uuid: `(uuid,eq,${uid})` },
  });

  const bookings = res.data.booking;
  return bookings && bookings.length ? bookings[0] : null;
}
